export enum contentHubMicrocopy {
  CONTENT_HUB_TITLE = 'CONTENT_HUB_TITLE',
  CONTENT_HUB_NEWSLETTER_TITLE = 'CONTENT_HUB_NEWSLETTER_TITLE',
  CONTENT_HUB_NEWSLETTER_SUBMIT = 'CONTENT_HUB_NEWSLETTER_SUBMIT',
  CONTENT_HUB_NEWSLETTER_SUCCESS = 'CONTENT_HUB_NEWSLETTER_SUCCESS',
  CONTENT_HUB_RELATED_ARTICLES_TITLE = 'CONTENT_HUB_RELATED_ARTICLES_TITLE',
}
